import { render, staticRenderFns } from "./gcfp.vue?vue&type=template&id=51f83ffb&scoped=true&"
import script from "./gcfp.vue?vue&type=script&lang=js&"
export * from "./gcfp.vue?vue&type=script&lang=js&"
import style0 from "./gcfp.vue?vue&type=style&index=0&id=51f83ffb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f83ffb",
  null
  
)

export default component.exports